import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import IRQuestionnairesListing from "../../../components/SidebarMenuComponents/OAComponent/IRQuestionnairesListing";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function IRQuestionnairesListingPage() {
    const location = useLocation();

    return (
        <Page title=" IR Questionnaires Listing| tiketic" >
           
            <StickyHeader title="IR Questionnaires Listing" />

            <ContentStyle>
                <IRQuestionnairesListing/>
            </ContentStyle>
        </Page>
    );
}

